import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { AnimatedLines } from './DecorativeElements';
import './WorkSection.css';

const WorkSection = () => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <section id="work" className="work-section" ref={ref}>
      <AnimatedLines />
      <div className="container">
        <motion.div
          className="work-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <div className="section-label">They trust us</div>
          <h2 className="section-title-work">
            Our latest<br />
            creative work
          </h2>
        </motion.div>

        <motion.div
          className="behance-portfolio-container"
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <div className="behance-embed-wrapper">
            <iframe 
              src="https://www.behance.net/embed/project/213828757?ilo0=1" 
              height="316" 
              width="404" 
              allowFullScreen 
              loading="lazy" 
              frameBorder="0" 
              allow="clipboard-write" 
              referrerPolicy="strict-origin-when-cross-origin"
              title="Team FullStack Portfolio"
            ></iframe>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WorkSection;
